import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import classNames from 'classnames';
import styles from './options-layout.module.scss';
import { useConfig } from '../../contexts/config-context';
import { NUMBER_OF_COLUMNS } from './options-layout-constants';
export const OptionsLayout = _ref => {
  let {
    numberOfColumns,
    children,
    ...rest
  } = _ref;
  const {
    isMobile
  } = useConfig();
  return /*#__PURE__*/React.createElement("div", _extends({
    className: classNames(styles.container, {
      [styles.oneColumn]: numberOfColumns === NUMBER_OF_COLUMNS.ONE || isMobile,
      [styles.twoColumns]: numberOfColumns === NUMBER_OF_COLUMNS.TWO && !isMobile,
      [styles.threeColumns]: numberOfColumns === NUMBER_OF_COLUMNS.THREE && !isMobile,
      [styles.freeFlow]: numberOfColumns === NUMBER_OF_COLUMNS.FREE_FLOW
    })
  }, rest), children);
};
//# sourceMappingURL=options-layout.js.map